import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { ValidateTokenSmsTypes } from '../Types';

const machine = Machines.onValidateTokenSms.machine;

export const validateTokenSms = (
  params: ValidateTokenSmsTypes.ValidateTokenSmsServiceRequestType,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { validateTokenSms };
